import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { IconButton } from '../IconButton/index';
import { Reveal } from '../Reveal/index';
export const expandingPanelCss = css `
  width: 100%;
  padding-top: ${theme.spacing.x8};
  padding-bottom: ${theme.spacing.x8};
  border-bottom: ${styleUtils.rem(1)} solid;
  border-color: ${theme.colors.gray300};
`;
export const toggleTextCss = css `
  ${theme.typeStyles.captionMediumStyles}
  padding-right: ${styleUtils.rem(10)};
  ${theme.media.lessThan('small') `
    display: none;
  `}
`;
export const buttonCss = css `
  ${styleUtils.buttonReset}
  color: ${theme.typeStyles.baseFontColor};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 0 ${theme.spacing.x3};
`;
export const containerCss = css `
  display: flex;
  align-items: center;
`;
export const titleContainerCss = css `
  margin-right: auto;
`;
export const closedContentContainerCss = ({ isVisible = false, }) => css `
  display: ${isVisible ? 'static' : 'none'};
  opacity: 0;
  animation: fadeIn ${theme.durationDefault};
  animation-delay: ${theme.durationDefault};
  animation-fill-mode: forwards;
  animation-timing-function: ${theme.easingDefault};

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
`;
const defaultProps = {
    className: '',
    closedContent: undefined,
    expandableEverywhere: false,
    onToggleClick: () => { },
    open: false,
    showToggle: true,
    title: '',
    toggleText: '',
};
const ExpandingPanel = ({ children, className = defaultProps.className, closedContent = defaultProps.closedContent, expandableEverywhere = defaultProps.expandableEverywhere, onToggleClick = defaultProps.onToggleClick, open = defaultProps.open, showToggle = defaultProps.showToggle, title = defaultProps.title, toggleText = defaultProps.toggleText, }) => (_jsxs("div", Object.assign({ className: className, css: expandingPanelCss }, { children: [_jsxs("div", Object.assign({ css: containerCss }, { children: [_jsx("div", Object.assign({ css: titleContainerCss }, { children: title })), showToggle && (_jsxs("button", Object.assign({ css: buttonCss, onClick: onToggleClick, type: "button" }, { children: [_jsx("span", Object.assign({ css: toggleTextCss }, { children: toggleText })), _jsx(IconButton, { iconType: open ? 'subtract' : 'add', size: "medium", type: "secondary" })] })))] })), _jsx(Reveal, Object.assign({ in: open, unmountOnExit: true }, { children: children })), _jsx("div", Object.assign({ css: closedContentContainerCss({
                isVisible: !open,
            }), onClick: expandableEverywhere ? onToggleClick : undefined, onKeyDown: expandableEverywhere ? onToggleClick : undefined, role: "button", tabIndex: 0 }, { children: closedContent }))] })));
const MemoizedExpandingPanel = memo(ExpandingPanel);
export { MemoizedExpandingPanel as ExpandingPanel };
// MC-1068 Temporary hack for Storybook.
export default ExpandingPanel;
